import { useDispatch, useSelector } from "react-redux";
import { selectSquares, calculateWinner, restartGame } from "./TicTacToeSlice";
import { Board } from "./Board";

export function TicTacToe() {
  const dispatch = useDispatch();

  const squares = useSelector(selectSquares);
  const winner = calculateWinner(squares);
  let status;
  if (winner) {
    status = (
      <>
        {winner + " wins!"}
        <a
          data-test-id="tic-tac-toe__play-again-link"
          className="btn px-6 py-3 me-3"
          onClick={() => dispatch(restartGame())}
        >
          Play again?
        </a>
      </>
    );
  }

  return (
    <div className="game">
      <div className="game-board">
        <Board />
      </div>
      <div className="game-info">{status}</div>
    </div>
  );
}
